import gql from 'graphql-tag'
import {
    CreateNavigationItem as CreateNavItem,
    CreateNavigationItemMutation as CreateNavItemMutation,
    CreateNavigationItemMutationVariables as CreateNavItemMutationVars,
    CreateNavigationMenu as CreateNavMenu,
    CreateNavigationMenuMutation as CreateNavMenuMutation,
    CreateNavigationMenuMutationVariables as CreateNavMenuMutationVars,
    CreateNavigationSubMenu as CreateNavSubMenu,
    CreateNavigationSubMenuMutation as CreateNavSubMenuMutation,
    CreateNavigationSubMenuMutationVariables as CreateNavSubMenuMutationVars,
    UpdateNavigationItemMutation as UpdateNavItemMutation,
    UpdateNavigationItemMutationVariables as UpdateNavItemMutationVars,
    UpdateNavigationMenuMutation as UpdateNavMenuMutation,
    UpdateNavigationMenuMutationVariables as UpdateNavMenuMutationVars,
    UpdateNavigationSubMenuMutation as UpdateNavSubMenuMutation,
    UpdateNavigationSubMenuMutationVariables as UpdateNavSubMenuMutationVars,
    DeleteNavigationItemMutation as DeleteNavItemMutation,
    DeleteNavigationItemMutationVariables as DeleteNavItemMutationVars,
    DeleteNavigationMenuMutation as DeleteNavMenuMutation,
    DeleteNavigationMenuMutationVariables as DeleteNavMenuMutationVars,
    DeleteNavigationSubMenuMutation as DeleteNavSubMenuMutation,
    DeleteNavigationSubMenuMutationVariables as DeleteNavSubMenuMutationVars,
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Create navigation item
const createNavItemMutation = gql`
    mutation createNavigationItem($input: CreateNavigationItem!) {
        createNavigationItem(data: $input) {
            id
            order
            text
            space {
                id
            }
        }
    }
`

// Create navigation menu
const createNavMenuMutation = gql`
    mutation createNavigationMenu($input: CreateNavigationMenu!) {
        createNavigationMenu(data: $input) {
            id
            order
            text
        }
    }
`

// Create navigation submenu
const createNavSubMenuMutation = gql`
    mutation createNavigationSubMenu($input: CreateNavigationSubMenu!) {
        createNavigationSubMenu(data: $input) {
            id
            order
            text
        }
    }
`

// Update navigation item
const updateNavItemMutation = gql`
    mutation updateNavigationItem($data: UpdateNavigationItem!, $id: ID!) {
        updateNavigationItem(data: $data, id: $id) {
            id
            order
            text
            space {
                id
            }
            linkedSpace {
                id
            }
        }
    }
`

// Update navigation menu
const updateNavMenuMutation = gql`
    mutation updateNavigationMenu($data: UpdateNavigationMenu!, $id: ID!) {
        updateNavigationMenu(data: $data, id: $id) {
            id
            order
            text
        }
    }
`

// Update navigation submenu
const updateNavSubMenuMutation = gql`
    mutation updateNavigationSubMenu($data: UpdateNavigationSubMenu!, $id: ID!) {
        updateNavigationSubMenu(data: $data, id: $id) {
            id
            order
            text
        }
    }
`

// Delete navigation item
const deleteNavItemMutation = gql`
    mutation deleteNavigationItem($id: ID!) {
        deleteNavigationItem(id: $id)
    }
`

// Delete navigation menu
const deleteNavMenuMutation = gql`
    mutation deleteNavigationMenu($id: ID!) {
        deleteNavigationMenu(id: $id)
    }
`

// Delete navigation submenu
const deleteNavSubMenuMutation = gql`
    mutation deleteNavigationSubMenu($id: ID!) {
        deleteNavigationSubMenu(id: $id)
    }
`

export const createNavigationItem = (input: CreateNavItem) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery <CreateNavItemMutation, CreateNavItemMutationVars>(createNavItemMutation)
    return query({ input })
}

export const createNavigationMenu = (input: CreateNavMenu) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery <CreateNavMenuMutation, CreateNavMenuMutationVars>(createNavMenuMutation)
    return query({ input })
}

export const createNavigationSubMenu = (input: CreateNavSubMenu) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery <CreateNavSubMenuMutation, CreateNavSubMenuMutationVars>(createNavSubMenuMutation)
    return query({ input })
}

export const updateNavigationItem = (data, id) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<UpdateNavItemMutation, UpdateNavItemMutationVars>(updateNavItemMutation)
    return query({ data, id })
}

export const updateNavigationMenu = (data, id) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<UpdateNavMenuMutation, UpdateNavMenuMutationVars>(updateNavMenuMutation)
    return query({ data, id })
}

export const updateNavigationSubMenu = (data, id) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<UpdateNavSubMenuMutation, UpdateNavSubMenuMutationVars>(updateNavSubMenuMutation)
    return query({ data, id })
}

export const deleteNavigationItem = (id) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<DeleteNavItemMutation, DeleteNavItemMutationVars>(deleteNavItemMutation)
    return query({ id })
}

export const deleteNavigationMenu = (id) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<DeleteNavMenuMutation, DeleteNavMenuMutationVars>(deleteNavMenuMutation)
    return query({ id })
}

export const deleteNavigationSubMenu = (id) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<DeleteNavSubMenuMutation, DeleteNavSubMenuMutationVars>(deleteNavSubMenuMutation)
    return query({ id })
}
